import { Injectable, inject } from '@angular/core';
import { CanActivateChild, Router, UrlTree, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { canAccessPaymentRoute } from '../utils/payment-access.util';

@Injectable({ providedIn: 'root' })
export class PaymentRouteGuard implements CanActivateChild {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivateChild(_childRoute: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const groups = this.authService.currentUser()?.group;
    const targetUrl = state?.url ?? this.router.url ?? '';
    if (canAccessPaymentRoute(groups, targetUrl)) {
      return true;
    }
    return this.router.createUrlTree(['/pages-dashboard']);
  }
}
